import React, { useEffect, useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthContext';
import { StudentContext } from '../../Context/StudentContext';

const Logout = (props) => {

    const { setIsAuthenticated } = useContext(AuthContext);
    const { resetStudent } = useContext(StudentContext)

    const logout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        resetStudent()
    }

    useEffect(() => {
        logout()
    }, []);

    return (
        <div>
            <Redirect to='/login' />
        </div>

    );
}
export default Logout